import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Colors, ColorsCSS } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import { TypographyPDL } from '../../../theme/Typography.es.js';
import '../../../theme/ZinniaStylesReset.es.js';
import { extend, colord } from 'colord';

var o=function(o){var t=o/255;return t<.04045?t/12.92:Math.pow((t+.055)/1.055,2.4)},t=function(t){return .2126*o(t.r)+.7152*o(t.g)+.0722*o(t.b)};function a11yPlugin(o){o.prototype.luminance=function(){return o=t(this.rgba),void 0===(r=2)&&(r=0),void 0===n&&(n=Math.pow(10,r)),Math.round(n*o)/n+0;var o,r,n;},o.prototype.contrast=function(r){void 0===r&&(r="#FFF");var n,a,i,e,v,u,d,c=r instanceof o?r:new o(r);return e=this.rgba,v=c.toRgb(),u=t(e),d=t(v),n=u>d?(u+.05)/(d+.05):(d+.05)/(u+.05),void 0===(a=2)&&(a=0),void 0===i&&(i=Math.pow(10,a)),Math.floor(i*n)/i+0},o.prototype.isReadable=function(o,t){return void 0===o&&(o="#FFF"),void 0===t&&(t={}),this.contrast(o)>=(e=void 0===(i=(r=t).size)?"normal":i,"AAA"===(a=void 0===(n=r.level)?"AA":n)&&"normal"===e?7:"AA"===a&&"large"===e?3:4.5);var r,n,a,i,e;};}

extend([a11yPlugin]);
const Styles = labelStyles("TagLabel", {
  root: (backgroundColor, textColor) => {
    return css`
      display: inline-flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      border-radius: var(--zds-radius-small, 30px);

      background-color: ${backgroundColor};
      color: ${textColor};

      &[data-size='small'] {
        height: auto;
        padding: var(--zds-space-0, 0) var(--zds-space-4, 8px);
        ${TypographyPDL("--zds-small-print-2", "smallPrint1Bold")}
      }

      &[data-size='medium'] {
        height: auto;
        padding: var(--zds-space-0, 3px) var(--zds-space-4, 8px);
        ${TypographyPDL("--zds-body-2", "smallPrint1Bold")}
      }

      /* TODO: PDL variant hardcoded for use in UniversalLayout, update values in v8 */
      &[data-color='simple'] {
        padding: var(--zds-space-0, 0) var(--zds-space-4, 4px);
        background-color: transparent;
        color: var(--zds-text-weakest, #6f6765);
        border: 1px solid var(--zds-stroke-default, #b5b2aa);
        border-radius: var(--zds-radius-small, 3px);
        font: var(--zds-small-print-2, 500 13px/20px Inter);
      }

      &[data-color='gray'] {
        background-color: var(--zds-gray-warm-9, ${Colors.neutral700});
        color: var(--zds-text-inverted, ${Colors.neutral100});
      }

      &[data-color='white'] {
        background-color: var(--zds-prime-white, ${Colors.neutral100});
        color: var(--zds-text-stronger, ${Colors.neutral800});
      }

      &[data-color='info'] {
        background-color: var(--zds-ui-primary-weaker, ${Colors.blue10});
        color: var(--zds-text-stronger, ${Colors.neutral800});
      }

      &[data-color='success'] {
        background-color: var(
          --zds-status-success-weaker,
          ${Colors.success100}
        );
        color: var(--zds-text-default, ${Colors.neutral800});
      }

      &[data-color='warning'] {
        background-color: var(
          --zds-status-warning-weaker,
          ${Colors.warning100}
        );
        color: var(--zds-text-default, ${Colors.neutral800});
      }

      &[data-color='error'] {
        background-color: var(--zds-status-error-weaker, ${Colors.error100});
        color: var(--zds-text-default, ${Colors.neutral800});
      }

      &[data-color='peach'] {
        background-color: ${ColorsCSS.peach};
        color: ${ColorsCSS.neutral800};
      }

      &[data-color='neutral300'] {
        background-color: ${ColorsCSS.neutral300};
        color: ${ColorsCSS.neutral800};
      }

      &[data-color='bolt'] {
        background-color: ${ColorsCSS.bolt};
        color: ${ColorsCSS.neutral800};
      }

      &[data-color='cream'] {
        background-color: ${ColorsCSS.cream};
        color: ${ColorsCSS.neutral800};
      }

      &[data-color='success500'] {
        background-color: ${ColorsCSS.success500};
        color: ${ColorsCSS.neutral100};
      }

      &[data-color='lavender'] {
        background-color: ${ColorsCSS.lavender};
        color: ${ColorsCSS.neutral800};
      }
    `;
  }
});
const tagLabelColors = [
  "simple",
  "gray",
  "white",
  "info",
  "success",
  "warning",
  "error",
  "peach",
  "neutral300",
  "bolt",
  "cream",
  "success500",
  "lavender"
];
const TagLabel = ({ children, color = "gray", size = "medium", className }) => {
  let backgroundColor = "neutral700";
  let textColor = "neutral100";
  if (tagLabelColors.find((tagColor) => tagColor === color)) {
    switch (color) {
      case "gray":
        backgroundColor = "neutral700";
        textColor = "neutral100";
        break;
      case "white":
        backgroundColor = "neutral100";
        textColor = "neutral800";
        break;
      case "info":
        backgroundColor = "blue10";
        textColor = "neutral800";
        break;
      case "success":
        backgroundColor = "success100";
        textColor = "neutral800";
        break;
      case "warning":
        backgroundColor = "warning100";
        textColor = "neutral800";
        break;
      case "error":
        backgroundColor = "error100";
        textColor = "neutral800";
        break;
      case "peach":
        backgroundColor = "peach";
        textColor = "neutral800";
        break;
      case "neutral300":
        backgroundColor = "neutral300";
        textColor = "neutral800";
        break;
      case "bolt":
        backgroundColor = "bolt";
        textColor = "neutral800";
        break;
      case "cream":
        backgroundColor = "cream";
        textColor = "neutral800";
        break;
      case "success500":
        backgroundColor = "success500";
        textColor = "neutral100";
        break;
      case "lavender":
        backgroundColor = "lavender";
        textColor = "neutral800";
        break;
    }
  } else {
    backgroundColor = color;
    const lightTextContrast = colord(Colors[backgroundColor]).contrast(Colors.neutral100);
    const darkTextContrast = colord(Colors[backgroundColor]).contrast(Colors.neutral800);
    if (lightTextContrast > darkTextContrast) {
      textColor = "neutral100";
    } else {
      textColor = "neutral800";
    }
  }
  return jsx("span", { css: Styles.root(Colors[backgroundColor], Colors[textColor]), "data-size": size, className, "data-color": color, "data-zds": true }, children);
};

export { Styles, TagLabel };
//# sourceMappingURL=TagLabel.es.js.map
